module.exports = __webpack_public_path__ + "24b901062b13f477accccae98ca538d3.png";